import { render, staticRenderFns } from "./EhrConfigurationSection.vue?vue&type=template&id=494b49b9&"
import script from "./EhrConfigurationSection.vue?vue&type=script&lang=js&"
export * from "./EhrConfigurationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports